import { useEffect, useState } from "react";

const navLinks = [
  { href: "#overview", label: "口碑总览" },
  { href: "#works", label: "作品榜" },
  { href: "#reviews", label: "深度影评" },
  { href: "#audience", label: "观众观后感" },
  { href: "#guide", label: "选片指南" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="px-4 md:px-6 h-16 md:h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-xl" />
          </span>
          <span className="font-heading font-bold text-lg text-foreground-950 tracking-wide">
            风驰影院
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center">
          <a
            href="#works"
            className="inline-flex items-center gap-1 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-bar-chart-box-line" />
            查看评分榜
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-expanded={menuOpen}
          aria-label="打开导航菜单"
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4">
          <div className="flex flex-col py-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-3 text-sm text-foreground-800 hover:bg-background-100 rounded-md cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#works"
            onClick={() => setMenuOpen(false)}
            className="w-full inline-flex items-center justify-center gap-1 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            <i className="ri-bar-chart-box-line" />
            查看评分榜
          </a>
        </div>
      )}
    </header>
  );
}